import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  CLONE_ORDER,
  DRAFT_ORDER_DETAILS,
  ERROR_LOG,
  ORDER_DETAILS,
  SUB_ORDER_DETAILS,
} from "../../constants/apiConstants";
import { postApi } from "../../../services/apiServices";
import Alertify from "../../../services/alertify";

/*----------------Order Details ---------------- */
export const OrderDetailsAPI = createAsyncThunk(
  "order-details-api/admin",
  async (reqData) => {
    try {
      const response = await postApi(ORDER_DETAILS, reqData);
      return response;
    } catch (error) {
      console.log("Error Order Details API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);

/*----------------Draft Order Details ---------------- */
export const DraftOrderDetailsAPI = createAsyncThunk(
  "draft-order-details-api/admin",
  async (reqData) => {
    try {
      const response = await postApi(DRAFT_ORDER_DETAILS, reqData);
      return response;
    } catch (error) {
      console.log("Error Draft Order Details API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);

/*----------------Order Errors ---------------- */
export const OrdersErrorAPI = createAsyncThunk(
  "orders-error-api/admin",
  async (reqData) => {
    try {
      const response = await postApi(ERROR_LOG, reqData);
      return response;
    } catch (error) {
      console.log("Error Order Errors API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);

/*----------------Clone Order ---------------- */
export const CloneOrderAPI = createAsyncThunk(
  "clone-order-api/admin",
  async (reqData) => {
    try {
      const response = await postApi(CLONE_ORDER, reqData);
      return response;
    } catch (error) {
      console.log("Error in Clone Order API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);
/*---------------- Sub Orders List ---------------- */
export const SubOrdersDetailsAPI = createAsyncThunk(
  "Sub_Orders_List/admin",
  async (reqData) => {
    try {
      const url = `${SUB_ORDER_DETAILS}?page=${encodeURIComponent(
        reqData.currentPage
      )}`;
      const response = await postApi(url, reqData);
      console.log("Sub Orders Details is :", response);
      return response;
    } catch (error) {
      console.log("Error Sub Orders Details API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);
